import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getInjectorTypesData(context) {
      const response = await Vue.axios.get(`${URL_API}injectortype`);
      let data = response["data"];
      context.commit("updateInjectorTypesData", data);
    },
    async createInjectorTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}injectortype/store`, body, config);
      context.dispatch("getInjectorTypesData");
    },
    async pushInjectorTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}injectortype/update`, body, config);
      context.dispatch("getInjectorTypesData");
    },
    async destroyInjectorTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}injectortype/destroy`, body, config);
      context.dispatch("getInjectorTypesData");
    }
  },
  mutations: {
    updateInjectorTypesData(state, injectorTypesData) {
      state.injectorTypesData = injectorTypesData;
    }
  },
  state: {
    injectorTypesData: []
  },
  getters: {
    allInjectorTypesData(state) {
      return state.injectorTypesData;
    }
  }
};